module.exports = "query emailValidate($email:String!){emailValidate(email:$email){id}}"